import {
  GET_SESSION_TOKEN_REQUEST,
  GET_SESSION_TOKEN_SUCCESS,
  GET_SESSION_TOKEN_FAILURE,

  SET_SESSION_TOKEN_REQUEST,
  SET_SESSION_TOKEN_SUCCESS,
  SET_SESSION_TOKEN_FAILURE,

  REMOVE_SESSION_TOKEN_REQUEST,
  REMOVE_SESSION_TOKEN_SUCCESS,
  REMOVE_SESSION_TOKEN_FAILURE
} from '../../constants/actions';

const initialState = {
  isFetching: false,
  isStoring: false,
  isDeleting: false,
  token: null,
  error: false
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case GET_SESSION_TOKEN_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false
      };
    case GET_SESSION_TOKEN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        token: action.token
      };
    case GET_SESSION_TOKEN_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    case SET_SESSION_TOKEN_REQUEST:
      return {
        ...state,
        isStoring: true,
        error: false
      };
    case SET_SESSION_TOKEN_SUCCESS:
      return {
        ...state,
        isStoring: false,
        token: action.token
      };
    case SET_SESSION_TOKEN_FAILURE:
      return {
        ...state,
        isStoring: false,
        error: action.error
      };
    case REMOVE_SESSION_TOKEN_REQUEST:
      return {
        ...state,
        isDeleting: true,
        error: false
      };
    case REMOVE_SESSION_TOKEN_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        token: null
      };
    case REMOVE_SESSION_TOKEN_FAILURE:
      return {
        ...state,
        isDeleting: false,
        error: action.error
      };
    default:
      return state;
  }
}
